import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { FabricasService} from  '../../shared/services/api/cadastros/FabricasService';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idfabrica: string;
  label: string;
}

interface IAutoCompleteFabricaProps {
  isExternalLoading?: boolean;
  uuidfabrica?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteFabrica: React.FC<IAutoCompleteFabricaProps> = ({ isExternalLoading = false, uuidfabrica, nome}) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idfabrica');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {  
      FabricasService.getAlllist(selectedId, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(fabrica => ({ idfabrica: fabrica.idfabrica, label: fabrica.nome })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idfabrica === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idfabrica); uuidfabrica?.(newValue?.idfabrica); nome?.(newValue?.label); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Fabricas"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};